import React from 'react'
import { Box, Heading, Tabs, TabList, Tab, TabPanels, TabPanel } from '@chakra-ui/react'
import { Link, useParams } from 'react-router-dom'

import useTitle from '../../hooks/useTitle'
import Profile from './Profile'
import Notifications from './Notifications'
import Account from './Account'
import Password from './Password'

export default function Settings () {
  useTitle('Settings')
  const { tabId } = useParams()

  const tabIndexMap = { profile: 0, notifications: 1, account: 2, security: 3 }
  const currentTabIndex = tabId ? tabIndexMap[tabId] : 0

  return (
    <Box p={10} width={{ md: '75%' }}>
      <Heading as='h2' size='lg' mb={5}>Manage your account</Heading>
      <Tabs index={currentTabIndex}>
        <TabList>
          <Tab as={Link} to='/settings/profile'>Profile</Tab>
          <Tab as={Link} to='/settings/notifications'>Notifications</Tab>
          <Tab as={Link} to='/settings/account'>Account</Tab>
          <Tab as={Link} to='/settings/security'>Password & security</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <Profile />
          </TabPanel>
          <TabPanel>
            <Notifications />
          </TabPanel>
          <TabPanel>
            <Account />
          </TabPanel>
          <TabPanel>
            <Password />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  )
}
